
































































































































































import { defineComponent, ref } from '~/utils/nuxt3-migration'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CStepper from '~/components/shared/configurable/stepper/CStepper.vue'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import LoanSection from '~/components/car/classifieds/view/partials/loans/LoanSection.vue'
import TbiLandingLoanSubmitButton from '~/components/car/classifieds/view/partials/loans/calculator/TbiLandingLoanSubmitButton.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import CBackToTop from '~/components/shared/configurable/CBackToTop.vue'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import useStatic from '~/compositions/static'
import { useBlackFriday } from '~/compositions/black-friday'

export default defineComponent({
  components: {
    CImg,
    CStepper,
    LoanSection,
    CCollapse,
    CCard,
    PlusMinusCollapseOpener,
    CBackToTop,
    TbiLandingLoanSubmitButton
  },
  setup() {
    const { t } = useI18n()
    const s = useStatic()

    const { isWithinTbiBlackFridayPeriod } = useBlackFriday()

    const isBlackFriday = isWithinTbiBlackFridayPeriod()

    const loanAmount = ref(15000)
    const loanInstallments = ref(48)
    const cardDetails = ref([
      {
        img: s('/nuxt-static/img/tbi/fast-process.svg'),
        scaleClass: 'xl:tw-scale-125',
        text: t('fast_and_digital_process'),
        textMobile: t('fast_process')
      },
      {
        img: s('/nuxt-static/img/tbi/instant-money.svg'),
        scaleClass: 'xl:tw-scale-125',
        text: isWithinTbiBlackFridayPeriod()
          ? t('with_interest_rate_bf')
          : t('with_interest_rate'),
        textMobile: t('instant_financing')
      },
      {
        img: s('/nuxt-static/img/tbi/no-surprises.svg'),
        scaleClass: 'xl:tw-scale-125',
        text: t('no_downpayment'),
        textMobile: t('no_surprises')
      },
      {
        img: s('/nuxt-static/img/tbi/online-process.svg'),
        scaleClass: 'xl:tw-scale-150 xl:tw-top-6',
        text: t('days_to_choose_vehicle'),
        textMobile: t('fully_digital')
      }
    ])

    const stepperSteps = Array(5).fill({
      label: '',
      completed: false,
      disabled: false,
      vertical: false,
      round: false,
      selected: true
    })

    const steps = ref([
      {
        hidden: false,
        img: s('/nuxt-static/img/tbi/step-1.png'),
        text: t('step_1_text')
      },
      {
        hidden: true,
        img: s('/nuxt-static/img/tbi/step-2.png'),
        text: t('step_2_text')
      },
      {
        hidden: true,
        img: s('/nuxt-static/img/tbi/step-3.png'),
        text: t('step_3_text')
      },
      {
        hidden: true,
        img: s('/nuxt-static/img/tbi/step-4.png'),
        text: t('step_4_text')
      },
      {
        hidden: true,
        img: s('/nuxt-static/img/tbi/step-5.png'),
        text: t('step_5_text')
      }
    ])

    const handleUpdateLoanAmount = (evt: number) => {
      loanAmount.value = evt
    }
    const handleUpdateLoanInstallments = (evt: number) => {
      loanInstallments.value = evt
    }
    const handleChangeStep = (evt: number) => {
      steps.value.forEach((step, i) => {
        i === evt && step.hidden === true
          ? (step.hidden = false)
          : (step.hidden = true)
      })
    }

    return {
      cardDetails,
      stepperSteps,
      steps,
      loanAmount,
      loanInstallments,
      handleChangeStep,
      handleUpdateLoanAmount,
      handleUpdateLoanInstallments,
      isBlackFriday
    }
  },
  i18n: defineComponentTranslations({
    with_only_five_steps: {
      en: 'With only 5 simple steps!',
      el: 'Με 5 μόνο απλά βήματα!'
    },
    fast_and_digital_process: {
      en: 'Fast & 100% digital process',
      el: 'Γρήγορη & 100% ψηφιακή διαδικασία'
    },
    fast_process: {
      en: 'Fast Process',
      el: 'Γρήγορη Διαδικασία'
    },
    with_interest_rate: {
      en: 'Interest rate <br> from 9.9%',
      el: 'Με επιτόκιο <br> από 9.9%'
    },
    with_interest_rate_bf: {
      en: 'Fixed interest <br> rate at 12%',
      el: 'Με σταθερό <br> επιτόκιο 12%'
    },
    instant_financing: {
      en: 'Instant Financing',
      el: 'Άμεση Χρηματοδότηση'
    },
    no_downpayment: {
      en: 'No downpayment or collateral required',
      el: 'Χωρίς προκαταβολή ή εγγύηση'
    },
    no_surprises: {
      en: 'No surprises',
      el: 'Χωρίς εκπλήξεις'
    },
    days_to_choose_vehicle: {
      en: '60 days period to choose a vehicle',
      el: '60 μέρες για να διαλέξεις όχημα'
    },
    fully_digital: {
      en: '100% Digital',
      el: '100% Ψηφιακά'
    },
    step: {
      en: 'Step',
      el: 'Βήμα'
    },
    step_1_text: {
      en:
        'You see the Ad you are interested in, you use the loan calculator with an indicative interest rate.',
      el:
        'Βλέπεις την Αγγελία που σε ενδιαφέρει και χρησιμοποιείς τον υπολογιστή δανείου με ένα ενδεικτικό επιτόκιο.'
    },
    step_2_text: {
      en:
        'Fill in the loan application digitally in a few minutes without having to visit a physical branch.',
      el:
        'Συμπληρώνεις την αίτηση χρηματοδότησης ψηφιακά σε μερικά λεπτά χωρίς να χρειαστεί επίσκεψη σε κατάστημα.'
    },
    step_3_text: {
      en: 'Get a reply after confirmation of your income and identity.',
      el:
        'Λαμβάνεις απάντηση μετά την επιβεβαίωση του εισοδήματος και της ταυτότητάς σου.'
    },
    step_4_text: {
      en:
        'Sign the contract online and select your Greek bank account to receive the money.',
      el:
        'Υπογράφεις τη σύμβαση ηλεκτρονικά και επιλέγεις τον Ελληνικό σου τραπεζικό λογαριασμό για να λάβεις τα χρήματα.'
    },
    step_5_text: {
      en:
        'You have 60 days, after signing the contract, to find the vehicle you want and send us a proof of purchase (e.g.car registration).',
      el:
        'Έχεις 60 ημέρες, μετά την υπογραφή της σύμβασης, να βρεις το όχημα που θες και να μας στείλεις ένα αποδεικτικό αγοράς (π.χ. άδεια κυκλοφορίας).'
    },
    hero_text: {
      en:
        'Say yes to a new car, motorcycle, scooter or even a boat with 100% online financing without any advance payment or guarantee. All without visiting the bank.',
      el:
        'Απόκτησε τώρα ό,τι επιθυμείς και πλήρωσε με ένα πλάνο δόσεων προσανατολισμένο στις ανάγκες σου. Ακόμη κι άν δεν έχεις όλα τα χρήματα άμεσα διαθέσιμα, μπορείς να αποκτήσεις το αυτοκίνητο, τη μοτοσυκλέτα ή το σκάφος που επιθυμείς με το "Πρόγραμμα Χρηματοδότησης" της <strong>tbi</strong> bank.'
    },
    hero_text_black_friday: {
      en:
        'Get the vehicle you want now with the most flexible financing plan, now and with 0€ management fees (Black Friday offer, valid from 29/11 to 02/12). Even if you don\'t have all the money immediately available, you can still get the car, the motorbike or the boat you want with tbi bank\'s "Financing Plan".',
      el:
        'Απόκτησε τώρα το όχημα που επιθυμείς με το πιο ευέλικτο πλάνο χρηματοδότησης, τώρα και με 0€ έξοδα διαχείρισης (Black Friday προσφορά, ισχύει από 29/11 έως και 02/12). Ακόμη κι αν δεν έχεις όλα τα χρήματα άμεσα διαθέσιμα, μπορείς να αποκτήσεις το αυτοκίνητο, τη μοτοσυκλέτα ή το σκάφος που επιθυμείς με το "Πρόγραμμα Χρηματοδότησης" της <strong>tbi</strong> bank.'
    }
  })
})
